import { call, put } from 'redux-saga/effects'
import BookActions from '../Redux/BookRedux'
import LoginActions from '../Redux/LoginRedux'
export function * book (api, { params }) {
  try {
    const res = yield call(api, params)
    if (res && res.message === 'Unauthenticated.') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.success) {
      yield put(BookActions.bookSuccess(res.data))
    } else {
      yield put(BookActions.bookFailure(res.message))
    }
  } catch (error) {
    yield put(BookActions.bookFailure(error.message))
  }
}

export function * getBookPreview (api, { params }) {
  try {
    const res = yield call(api, params)
    if (res.success) {
      yield put(BookActions.bookPreviewSuccess(res.data))
    } else {
      yield put(BookActions.bookPreviewFailure(res.message))
    }
  } catch (error) {
    yield put(BookActions.bookPreviewFailure(error.message))
  }
}
